export default __webpack_public_path__ + "static/media/angpao-cn.83d13ed4.webp";